/**
 * FileUploadContainer.js
 * Created by Ajit on 09/20/2021.
 */

import React from 'react';
import FileUpload from './FileUpload';
import {fileTypesUpload} from '../../../util/uiconstants';
import styled from 'styled-components';

export default function FileUploadContainer({
	parentName,
	taskId,
	entityType,
	uploadButtonText,
	documentType,
	buttonType,
	className,
	bodyId,
	uploadButtonIsLink,
	requireValidations,
	dragDropEnabled,
	uploadBrowseEnabled,
	children,
	payloadRef,
	relatedTasks,
	signoffRequirements,
	documentUploadComplete,
	bodyTypeId,
	showCrashDocumentWarningMessage = false,
	isDisabled
}) {
	return (
		<StyledFileUploadContainer className="StyledFileUploadContainer">
			<FileUpload
				parentName={parentName}
				dragDropText={'Drag and drop documents or'}
				uploadButtonText={uploadButtonText}
				allowedOutputFileExtensions={fileTypesUpload.options}
				entityType={entityType}
				documentType={documentType}
				dragDropEnabled={dragDropEnabled}
				uploadBrowseEnabled={uploadBrowseEnabled}
				overrideClassName={'upload-browse'}
				taskId={taskId}
				buttonType={buttonType}
				className={className}
				bodyId={bodyId}
				payloadRef={payloadRef}
				uploadButtonIsLink={uploadButtonIsLink}
				requireValidations={requireValidations}
				relatedTasks={relatedTasks}
				signoffRequirements={signoffRequirements}
				documentUploadComplete={documentUploadComplete}
				bodyTypeId={bodyTypeId}
				showCrashDocumentWarningMessage={showCrashDocumentWarningMessage}
				isDisabled={isDisabled}
			>
				{children}
			</FileUpload>
		</StyledFileUploadContainer>
	);
}

const StyledFileUploadContainer = styled.section``;
